import Const from 'const';

interface Dependencies {
    readonly subscribed: boolean;
}

interface SocketIOInterface {
    isSubscribed(): boolean;
}

class SocketIO implements SocketIOInterface {
    private dependencies: Dependencies;
    constructor(dependencies: Dependencies) {
        this.dependencies = dependencies;
    }
    public isSubscribed(): boolean {
        return Boolean(this.dependencies.subscribed);
    }
}

const defaultState = new SocketIO({subscribed: false});

export default function (state = defaultState, action) {
    if (action.type === Const.SOCKET_SUBSCRIBE) {
        state = new SocketIO({subscribed: true});
    } else if (inArray(action.type, [Const.SOCKET_UNSUBSCRIBE, Const.FILTER_BY_SLATE])) {
        state = new SocketIO({subscribed: false});
    }

    return state;
}
